import Pusher from 'pusher-js'

if ('Notification' in window) {
  Notification.requestPermission()
}

export default {
  install(app, options = {}) {
    const { appKey, cluster } = {
      appKey: window?.InertiaProps?.pusher?.app_key,
      cluster: window?.InertiaProps?.pusher?.app_cluster,
      ...options,
    }

    window.Pusher = new Pusher(appKey, {
      cluster,
      encrypted: true,
    })

    app.config.globalProperties.$pusher = window.Pusher
  },
}
